<div class="container">
  <div class="col-md-12">
    <!-- Header -->
    <div class="driver-header">
      <!-- Name row spans full width above the columns -->
      <div class="driver-name-row">
        <h2 class="driver-name">{{ driver.name || "New" }} {{ driver.lastName || "Driver" }}</h2>
        <span
          class="status-pill"
          [ngClass]="
            !driver.isActive ? 'status-inactive' : driver.isOffToday ? 'status-off' : 'status-on'
          "
        >
          {{ !driver.isActive ? "Inactive" : driver.isOffToday ? "Off" : "On" }}
        </span>
        <div class="avatar-sync-group">
          <span class="avatar-sync-label">{{ getAvatarSyncLabel() }}</span>
          <button
            pButton
            type="button"
            [icon]="isSyncingAvatar ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"
            label="Sync"
            class="p-button-sm avatar-sync-btn"
            (click)="triggerAvatarSync()"
            [disabled]="isSyncingAvatar"
          ></button>
        </div>
      </div>
      <div class="driver-header-content">
        <!-- Profile Picture Section -->
        <div class="driver-image-section" [class.editable]="isEditMode">
          <img [src]="profilePicture" alt="Driver Photo" class="driver-profile-image" />
          <div *ngIf="isFirst90Days()" class="first-90-days-badge">First 90 Days</div>
          <div *ngIf="isEditMode" class="image-overlay" (click)="profilePictureInput.click()">
            <div class="overlay-content">
              <i class="fa fa-camera"></i>
              <span>Change Photo</span>
            </div>
          </div>
          <input
            type="file"
            #profilePictureInput
            accept="image/*"
            (change)="onProfilePictureSelected($event)"
            style="display: none"
            aria-label="Upload profile picture"
          />
        </div>

        <!-- Driver Info Section -->
        <div class="driver-info-section">
          <div class="driver-basic-info">
            <div class="info-item">
              <strong>Type:</strong>
              {{ getDisplayType(driver.type) || "N/A" }}
            </div>
            <div class="info-item" *ngIf="getLessorName()">
              <strong>Lessor:</strong>
              {{ getLessorName() }}
            </div>
            <div class="info-item">
              <strong>Phone:</strong>
              {{ driver.cellphone || driver.phone || "N/A" }}
            </div>
            <div class="info-item">
              <strong>Email:</strong>
              {{ driver.email || "N/A" }}
            </div>
          </div>

          <!-- Product Qualifications -->
          <div
            class="product-qualifications"
            *ngIf="
              getActiveProductQualifications().length > 0 ||
              getPrequalifiedProductQualifications().length > 0
            "
          >
            <div class="qualification-list">
              <span
                class="qualification-badge"
                *ngFor="let qual of getActiveProductQualifications()"
                >{{ qual }}</span
              >
              <span
                class="qualification-badge prequalified"
                *ngFor="let qual of getPrequalifiedProductQualifications()"
                >{{ qual }} <span class="pre-q-label">Pre-Q</span></span
              >
            </div>
          </div>
        </div>

        <!-- PeopleNet Info Section -->
        <div class="peoplenet-section">
          <div class="peoplenet-info">
            <div class="info-item">
              <i class="fa fa-map-marker"></i><strong>Location:</strong> {{ getCurrentLocation() }}
            </div>
            <div class="info-item">
              <strong>Miles (7d):</strong> {{ getLast7DaysMiles() }}
              <span class="separator">|</span> <strong>HOS:</strong> {{ getHoursOfService() }}
            </div>
            <div class="info-item">
              <strong>Tractor:</strong> {{ getTractorNumber() }} <span class="separator">|</span>
              <strong>Trailer:</strong> {{ getTrailerNumber() }}
            </div>
            <div class="info-item">
              <strong>Auto Transmission Only:</strong>
              {{ driver.autoTransmissionOnly ? "Yes" : "No" }}
            </div>
          </div>

          <!-- Compliance Tags -->
          <div
            class="compliance-tags"
            *ngIf="hasDoNotDispatch() || hasOutOfCompliance() || hasExpiringSoon()"
          >
            <div class="tag tag-danger" *ngIf="hasDoNotDispatch()">
              <i class="fa fa-ban"></i> Do Not Dispatch
            </div>
            <div class="tag tag-warning" *ngIf="hasOutOfCompliance()">
              <i class="fa fa-exclamation-triangle"></i> Out of Compliance
            </div>
            <div class="tag tag-info" *ngIf="hasExpiringSoon()">
              <i class="fa fa-clock-o"></i> Expiring Soon
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex" style="justify-content: space-between; align-items: center">
      <ul class="nav nav-tabs" role="tablist">
        <li *ngIf="canViewProfileTab()" class="nav-item" [class.active]="selectedTab === 'profile'">
          <a class="nav-link" (click)="onTabClicked('profile')" aria-label="Navigate to Profile tab"
            >PROFILE</a
          >
        </li>
        <li
          *ngIf="canViewComplianceTab()"
          class="nav-item"
          [class.active]="selectedTab === 'compliance'"
        >
          <a
            class="nav-link"
            (click)="onTabClicked('compliance')"
            aria-label="Navigate to Compliance tab"
            >COMPLIANCE</a
          >
        </li>
        <li *ngIf="canViewNotesTab()" class="nav-item" [class.active]="selectedTab === 'notes'">
          <a class="nav-link" (click)="onTabClicked('notes')" aria-label="Navigate to Notes tab"
            >NOTES</a
          >
        </li>
        <li
          *ngIf="!isNewDriver && canViewScheduleTab()"
          class="nav-item"
          [class.active]="selectedTab === 'schedule'"
        >
          <a
            class="nav-link"
            (click)="onTabClicked('schedule')"
            aria-label="Navigate to Schedule tab"
            >SCHEDULE</a
          >
        </li>
        <li
          *ngIf="canViewAssignmentsTab()"
          class="nav-item"
          [class.active]="selectedTab === 'assignments'"
        >
          <a
            class="nav-link"
            (click)="onTabClicked('assignments')"
            aria-label="Navigate to Assignments tab"
            >ASSIGNMENTS</a
          >
        </li>
        <li
          *ngIf="!isNewDriver && canViewTeamsTab()"
          class="nav-item"
          [class.active]="selectedTab === 'teams'"
        >
          <a class="nav-link" (click)="onTabClicked('teams')" aria-label="Navigate to Team tab"
            >TEAM</a
          >
        </li>
        <li
          *ngIf="!isNewDriver && canViewSettlementsTab()"
          class="nav-item"
          [class.active]="selectedTab === 'settlements'"
        >
          <a
            class="nav-link"
            (click)="onTabClicked('settlements')"
            aria-label="Navigate to Settlements tab"
            >SETTLEMENTS</a
          >
        </li>
      </ul>
    </div>

    <div class="tab-content white-bg-tabs">
      <div *ngIf="selectedTab === 'profile' && canViewProfileTab()">
        <app-driver-profile
          [driver]="driver"
          [isEditMode]="isEditMode && canEditProfileTab()"
          [isNewDriver]="isNewDriver"
          [states]="states"
          [phoneMask]="phoneMask"
          [dateInputMask]="dateInputMask"
          [peopleNetSummary]="peopleNetSummary"
          (hasChanges)="onTabHasChanges($event)"
          (driverNoUpdated)="updatedDriverNo()"
          (driverTypeChange)="driverTypeChanged()"
        ></app-driver-profile>
      </div>

      <div *ngIf="selectedTab === 'compliance' && canViewComplianceTab()">
        <app-driver-compliance
          [driver]="driver"
          [isEditMode]="isEditMode && canEditComplianceTab()"
          [dateInputMask]="dateInputMask"
          [productQualificationsList]="productQualifications"
          [loadingProductQualifications]="loadingProductQualifications"
          (hasChanges)="onTabHasChanges($event)"
        ></app-driver-compliance>
      </div>

      <div *ngIf="selectedTab === 'notes' && canViewNotesTab()">
        <app-driver-notes
          [driver]="driver"
          [isEditMode]="isEditMode"
          [canEdit]="canEditNotesTab()"
          (hasChanges)="onTabHasChanges($event)"
        ></app-driver-notes>
      </div>

      <div *ngIf="selectedTab === 'schedule' && canViewScheduleTab()">
        <app-driver-schedule
          [driver]="driver"
          [isEditMode]="isEditMode && canEditScheduleTab()"
          (hasChanges)="onTabHasChanges($event)"
        ></app-driver-schedule>
      </div>

      <div *ngIf="selectedTab === 'assignments' && canViewAssignmentsTab()">
        <app-driver-assignments
          [driver]="driver"
          [isEditMode]="isEditMode && canEditAssignmentsTab()"
          [tractors]="tractors"
          [trailers]="trailers"
          [clients]="clients"
          [fuelRegions]="fuelRegions"
          [loadingTractors]="loadingTractors"
          [loadingTrailers]="loadingTrailers"
          [loadingClients]="loadingClients"
          [loadingFuelRegions]="loadingFuelRegions"
          (hasChanges)="onTabHasChanges($event)"
        ></app-driver-assignments>
      </div>

      <div *ngIf="selectedTab === 'teams' && canViewTeamsTab()">
        <app-driver-teams
          [driver]="driver"
          [isEditMode]="isEditMode && canEditTeamsTab()"
          (hasChanges)="onTabHasChanges($event)"
          (teamSaved)="onTeamSaved()"
        ></app-driver-teams>
      </div>

      <div *ngIf="selectedTab === 'settlements' && canViewSettlementsTab()">
        <app-driver-settlements
          [driver]="driver"
          [isEditMode]="isEditMode && canEditSettlementsTab()"
        ></app-driver-settlements>
      </div>
    </div>

    <!-- Footer -->
    <div class="driver-footer">
      <div class="footer-left"></div>
      <div class="footer-right">
        <button class="btn btn-secondary" (click)="navigateToList()">
          <i class="fa fa-arrow-left"></i>
          Back to List
        </button>
        <button
          *ngIf="isEditMode"
          type="button"
          class="btn btn-secondary"
          (click)="cancelEdit()"
          [disabled]="isProcessing"
        >
          Cancel
        </button>
        <button
          *ngIf="!isNewDriver && canEditAnyTab()"
          type="button"
          class="btn btn-primary"
          (click)="toggleEditMode()"
          [disabled]="isProcessing"
        >
          {{ isEditMode ? "Save Changes" : "Edit Profile" }}
        </button>
        <button
          *ngIf="isNewDriver"
          type="button"
          class="btn btn-primary"
          (click)="saveDriver()"
          [disabled]="isProcessing"
        >
          Create Driver
        </button>
      </div>
    </div>
  </div>
</div>
